<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getUserInfo as getUserInfoFromStorage } from '@/utils/auth'

export default {
  name: 'App',
  computed: {
    ...mapGetters('user', ['token', 'userInfo'])
  },
  async created() {
    console.log('========== App created 开始 ==========')
    console.log('token:', this.token)
    console.log('userInfo from store:', this.userInfo)

    // 检查localStorage中的数据
    const storedUserInfo = getUserInfoFromStorage()
    console.log('localStorage中的用户信息:', storedUserInfo)
    const storedPermissions = localStorage.getItem('system_permissions')
    console.log('localStorage中的权限:', storedPermissions)

    // 如果有token但localStorage中有用户信息，直接恢复到store
    if (this.token) {
      if (storedUserInfo && !this.userInfo) {
        // 将localStorage中的用户信息恢复到store
        this.$store.commit('user/SET_USERINFO', storedUserInfo)
        console.log('已恢复用户信息到store:', storedUserInfo)
      }
      // 恢复权限信息
      if (storedPermissions && storedPermissions !== 'null') {
        const permissions = JSON.parse(storedPermissions)
        this.$store.commit('user/SET_PERMISSIONS', permissions)
        console.log('已恢复权限到store:', permissions)
      }

      // 尝试从后端获取最新的用户信息和权限
      try {
        await this.getUserInfo()
        console.log('从后端获取用户信息成功')
      } catch (error) {
        // token失效，清除本地存储
        console.error('token失效:', error)
        await this.$store.dispatch('user/logout')
      }
    }
  },
  methods: {
    ...mapActions('user', ['getUserInfo'])
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
